export default __webpack_public_path__ + "static/clustermesh-2-27684f5920986da228e349f3e782bb42.png";